export enum PAGINATION_ACTIONS {
  INCREMENT_PAGE = "incrementPage",
  DECREMENT_PAGE = "decrementPage",
  UPDATE_PAGE_SIZE = "updatePageSize",
  UPDATE_PAGE_COUNT = "setPageCount",
  SET_PAGE = "setPage",
}

function paginationReducer(
  state: { pageIndex: number; pageSize: number; pageCount: number },
  action: { type: string; payload?: number }
) {
  
  if (action.type === PAGINATION_ACTIONS.INCREMENT_PAGE) {
    return {
      ...state,
      pageIndex: state.pageIndex + 1,
    };
  }

  if (action.type === PAGINATION_ACTIONS.DECREMENT_PAGE) {
    return {
      ...state,
      pageIndex: state.pageIndex - 1,
    };
  }

  if (action.type === PAGINATION_ACTIONS.UPDATE_PAGE_SIZE) {
    return {
      ...state,
      pageSize: action.payload,
    };
  }

  if (action.type === PAGINATION_ACTIONS.UPDATE_PAGE_COUNT) {
    return {
      ...state,
      pageCount: action.payload,
    };
  }

  if (action.type === PAGINATION_ACTIONS.SET_PAGE) {
    return {
      ...state,
      pageIndex: action.payload,
    };
  }
}

export default paginationReducer;
